import React from 'react';
import { OrderDirection, LensFieldsByIdQueryVariables, LensFieldsByIdQuery, LensFieldsByIdFieldsConnectionNodesFragment, LensFieldOrderField , LensFieldsByIdDocument } from '../../../../../gen-src/queries';
import { ConnectionListResult, GridSortProps, PaginatedQueryWrapper } from '../../../data-catalog-shared';
import { iconForField } from '../field/functions/FieldFunctions';
import { FieldsValidSortFields } from '../sorting/sortProviders/FieldsGridSortProvider';
import { LensFieldsDisplayGrid, LensFieldsDisplayGridRowData } from './LensFieldsDisplayGrid';

export type LensFieldsQueryGridProps = GridSortProps<FieldsValidSortFields> & Readonly<{
  vizportalUrlId: string;
  rowCount: number | null;
}>;

export type QueryVariables = LensFieldsByIdQueryVariables;
export type QueryResults = LensFieldsByIdQuery;
export type QueryResultListNode = LensFieldsByIdFieldsConnectionNodesFragment;
export type GridRowData = LensFieldsDisplayGridRowData;

const selectConnectionListResult = (resultData: QueryResults): ConnectionListResult<QueryResultListNode> | null => {
  return resultData?.lenses[0] && resultData.lenses[0].fieldsConnection;
}

const mapResultNode = (field: QueryResultListNode, resultData: QueryResults): GridRowData => {
  return {
    ...field.datasourceField,
    dataType: 'dataType' in field.datasourceField ? field.datasourceField.dataType : null,
    lensId: resultData.lenses[0].vizportalUrlId,
    fieldIcon: iconForField(field.datasourceField),
    id: field.id,
    name: field.name || field.datasourceField.name,
    description: field.description || field.datasourceField.description,
  };
}

export const LensFieldsQueryGrid: React.FC<LensFieldsQueryGridProps> = React.memo(props => {
  return <PaginatedQueryWrapper<
    QueryVariables, QueryResults, QueryResultListNode, GridRowData>
    queryGql={LensFieldsByIdDocument}
    partialQueryVariables={{ vizportalUrlId: props.vizportalUrlId, orderBy: { field: LensFieldOrderField.ID, direction: OrderDirection.DESC } }}
    selectConnectionListResult={selectConnectionListResult}
    mapResultNode={mapResultNode}>
    {({ rowStore }) => (
      <LensFieldsDisplayGrid
        rowStore={rowStore}
        orderBy={props.orderBy}
        updateSortOrder={props.updateSortOrder} />
    )}
  </PaginatedQueryWrapper >;
});
